import Component from 'can/component/component';

import {
    getFieldName,
    WIN_PROBABILITY,
    TOP_10_PROBABILITY,
    MAKE_CUT_PROBABILITY,
    WIN_PROBABILITY_VS_LEADERS,
} from '../types';
import {
    sendVsToggleAnalytics,
    sendTabChangeAnalytics,
    getPlayerName,
} from '../controllers/analytics.controller';

import template from './header-menu.stache';
import { PROBABILITY_PAGE_TYPE } from 'components/probability/tooltip-handler';

export default Component.extend({
    tag: 'probability-header-menu',
    template,
    viewModel: {
        define: {
            winProbability: {
                type: 'string',
                value: WIN_PROBABILITY,
            },
            winProbabilityWithLeaders: {
                type: 'string',
                value: 'win probability vs leaders',
            },
            top10Probability: {
                type: 'string',
                value: TOP_10_PROBABILITY,
            },
            makeCutProbability: {
                type: 'string',
                value: MAKE_CUT_PROBABILITY,
            },
            currentProbabilityType: {
                type: 'string',
            },
            showMenu: {
                type: 'boolean',
                value: false,
            },
            player: {
                type: 'object',
            },
        },
        getFieldNameByType(type) {
            return getFieldName(type);
        },
    },
    events: {
        inserted() {
            this.viewModel.bind(
                'currentProbabilityType',
                (__, probabilityType) => {
                    if (probabilityType === WIN_PROBABILITY_VS_LEADERS) {
                        return sendVsToggleAnalytics(
                            this.viewModel.attr('player'),
                        );
                    }
                    sendTabChangeAnalytics(
                        probabilityType,
                        getPlayerName(this.viewModel.attr('player')),
                        PROBABILITY_PAGE_TYPE.PLAYER_DETAIL,
                    );
                },
            );
        },
        '.js-menu-item click'() {
            this.viewModel.attr('showMenu', !this.viewModel.attr('showMenu'));
        },
        '.js-label click'($el) {
            const probabilityType = $el.attr('data-type');

            this.viewModel.attr('currentProbabilityType', probabilityType);
            this.viewModel.attr('showMenu', false);
        },
        '{document} click'(element, event) {
            if (this.viewModel.attr('showMenu')) {
                if (!this.element.get(0).contains(event.target)) {
                    this.viewModel.attr('showMenu', false);
                }
            }
        },
    },
});
